import { FunctionComponent } from 'react';
import { EmptyStateProps } from './types';
import { EmptyStateWrapper } from './styles';
import images from '../../../assets';

const EmptyState: FunctionComponent<EmptyStateProps> = (props: EmptyStateProps) => {
    return (
        <EmptyStateWrapper className={props.className}>
            <img
                src={images['emptyStateIcon']}
                className='empty-state-icon'
                alt='Empty state icon'
            />
            <h5>{props.title}</h5>
            <p>{props.message}</p>
        </EmptyStateWrapper>
    );
};

EmptyState.defaultProps = {
    title: 'No Data Found',
    message: 'It looks like there’s nothing here yet. Add new data to get started.',
    className: 'arcadis-empty-state'
};

export default EmptyState;
